import "./usercomponent.scss";
import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeLoggedInUser } from "../../services/Auth";
import { FaChevronDown } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import { logout } from "../../Store/modules/userSlice";
import { logoutSelectedLink } from "../../Store/modules/selectedLinkSlice";
import { logoutSelectedCompany } from "../../Store/modules/selectedCompany";
import { logoutSelectedMoreCompany } from "../../Store/modules/selectedMoreAbout";
import { logoutSelectedLanguage } from "../../Store/modules/selectedLanguage";
import { useTranslation } from "react-i18next";

function UserComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [openUser, setOpenUser] = useState(false);
  const menuDrop = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuDrop.current &&
        !menuDrop.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setOpenUser(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    dispatch(logoutSelectedLink());
    dispatch(logoutSelectedCompany());
    dispatch(logoutSelectedMoreCompany());
    dispatch(logoutSelectedLanguage());
    if (props.callback) props.callback();
    removeLoggedInUser();
    navigate("/Pages/LoginPage/");
  };

  const initial = user?.name ? user.name.charAt(0).toUpperCase() : "U";

  return (
    <div className="user-profile-container">
      <button
        ref={triggerRef}
        type="button"
        className={`user-profile-trigger ${openUser ? 'active' : ''}`}
        onClick={() => setOpenUser(!openUser)}
        title={user?.name || "Utilizador"}
      >
        <div className="user-avatar-circle">
          <span>{initial}</span>
        </div>
        <FaChevronDown
          size={9}
          className={`user-caret ${openUser ? 'rotate' : ''}`}
        />
      </button>

      {openUser && (
        <div ref={menuDrop} className="user-dropdown-menu">
          <div className="user-dropdown-header">
            <span className="user-name-text">{user?.name || "Utilizador"}</span>
          </div>
          <div className="user-dropdown-divider" />
          <button
            onClick={handleLogout}
            className="user-dropdown-item logout-item"
          >
            <RiLogoutBoxLine size={15} />
            <span>{t('Sair')}</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default UserComponent;
